export default __webpack_public_path__ + "static/media/staminapot.daca5cfc.PNG";